module.exports = __webpack_public_path__ + "static/img/1108完稿改圖與字300x300.c1b89592.png";